import axios from "axios";

const enc = encodeURIComponent;
const BASE = "/analytics-reports";

// Plain `axios` import — this app's shared instance (src/services/axios.js)
// already sets baseURL/withCredentials/the auth-header interceptor globally.
// Analytics reports now live in way2news_ads_api_2_0 behind the same
// JWT + ops-role auth as every other panel API.

// "Site ID wise" tab
export const fetchSites = (params) => axios.post(`${BASE}/sites`, params).then((r) => r.data);

export const fetchCustIdsForSite = (siteId, params) =>
  axios.post(`${BASE}/sites/${enc(siteId)}/custids`, params).then((r) => r.data);

// "Cust ID wise" tab
export const fetchCustIds = (params) => axios.post(`${BASE}/custids`, params).then((r) => r.data);

export const fetchSitesForCustId = (custId, params) =>
  axios.post(`${BASE}/custids/${enc(custId)}/sites`, params).then((r) => r.data);

// Popup modal — same underlying data regardless of which tab got you here
export const fetchEvents = (siteId, custId, eventName, params) =>
  axios.post(`${BASE}/sites/${enc(siteId)}/custids/${enc(custId)}/eventnames/${enc(eventName)}/events`, params).then((r) => r.data);

// Popup modal for a custom alt/title/text column cell click
export const fetchSearchEvents = (siteId, custId, term, params) =>
  axios.post(`${BASE}/sites/${enc(siteId)}/custids/${enc(custId)}/search-events`, { ...params, term }).then((r) => r.data);

// CSV variants return a flat row array (fed straight to react-csv's
// CSVLink) instead of a downloadable file URL — these endpoints require
// auth now, which a plain anchor tag can't attach.
export const fetchSitesCsv = (params) => axios.post(`${BASE}/sites/csv`, params).then((r) => r.data.data.items);

export const fetchCustIdsCsv = (params) => axios.post(`${BASE}/custids/csv`, params).then((r) => r.data.data.items);

export const fetchCustIdsForSiteCsv = (siteId, params) =>
  axios.post(`${BASE}/sites/${enc(siteId)}/custids/csv`, params).then((r) => r.data.data.items);

export const fetchSitesForCustIdCsv = (custId, params) =>
  axios.post(`${BASE}/custids/${enc(custId)}/sites/csv`, params).then((r) => r.data.data.items);

export const fetchEventsCsv = (siteId, custId, eventName, params) =>
  axios.post(`${BASE}/sites/${enc(siteId)}/custids/${enc(custId)}/eventnames/${enc(eventName)}/events/csv`, params).then((r) => r.data.data.items);

export const fetchSearchEventsCsv = (siteId, custId, term, params) =>
  axios.post(`${BASE}/sites/${enc(siteId)}/custids/${enc(custId)}/search-events/csv`, { ...params, term }).then((r) => r.data.data.items);
